// extracted by mini-css-extract-plugin
module.exports = {"root":"RuleRef_root__3wEOF"};